import { Fragment } from "react";
import useAxios from "axios-hooks";
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { Button, Table, Container, Row, Col, Form } from "react-bootstrap";
import { FaCopy } from 'react-icons/fa'
import { format } from 'date-fns'
import { stringify } from 'csv-stringify/browser/esm/sync';
function BulkCodes() {

    const authHeader = useAuthHeader()
    const authUser = useAuthUser()
    const [{ data: bulkCodesData, lloading: loadingBulkCodes, error: errorLoadingBulkCodes }, refetchBulkCodes] = useAxios(
        {
            url: '/pr/bulk-codes',
            method: 'GET',
            withCredentials: true,
            headers: {
                "Authorization": authHeader()
            }
        }
    )

    const downloadCSV = async function () {
        const bulkCodesDownload = (bulkCodesData?.bulkCodes || []).map(bc => {
            return {
                "code": bc.sk,
                "brand": `${bc.accountName} | ${bc.brandName}`,
                "status": bc.isk,
                "expires": bc.expires
            }
        })
        const csv = stringify(bulkCodesDownload || [], { header: true })
        const url = window.URL.createObjectURL(new Blob([csv]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `swiftrev-bulk-codes.csv`);
        document.body.appendChild(link);
        link.click();
    }

    return (
        <Fragment>
            <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <h1>My Press Release Purchased Codes</h1>
                <br></br>
                <Row>
                    <Col md={{ span: 6, order: 3 }} style={{ padding: "15px" }} xs={{ span: 12, order: 2 }}>
                        <Form.Control type="email"
                            readOnly={true}
                            value={authUser().email} />
                    </Col>
                    <Col md={{ span: 6, order: 3 }} style={{ padding: "15px" }} xs={{ span: 12, order: 2 }}>
                        <div className="fw-bold" style={{ fontSize: "16px", lineHeight: "18px" }}>Need help? Looking for more codes?</div>
                        <div style={{ fontSize: "16px", lineHeight: "18px" }}>Reach out to your Account Manager.</div>
                    </Col>
                </Row>
                <br />
                <Button onClick={() => downloadCSV()} >Download Codes</Button>
                <br />
                <Table>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Brand</th>
                            <th>Status</th>
                            <th>Press Release</th>
                            <th>Expires</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (bulkCodesData?.bulkCodes || []).map((bc => {
                                return (
                                    <tr>
                                        <td>
                                            {bc.isk !== 'used' &&
                                                <Fragment>
                                                    <Button onClick={() => { navigator.clipboard.writeText(bc.sk) }}
                                                        variant="outline-secondary" size="sm" style={{ border: 'none' }}><FaCopy /></Button> <span>{bc.sk}</span>
                                                </Fragment>
                                            }
                                            {bc.isk === 'used' && <span className="text-secondary">{bc.sk}</span>}
                                        </td>
                                        <td><a target="_blank" rel="noreferrer" href={bc.ecommUrl}>{bc.accountName} | {bc.brandName}</a></td>
                                        <td>{bc.isk}</td>
                                        <td>
                                            {bc.isk === 'used' &&
                                                <span><a style={{ marginRight: "15px" }} target="_blank" rel="noreferrer" href={bc.prUrl}>View</a><a target="_blank" rel="noreferrer" href={bc.prEditUrl}>Edit</a></span>
                                            }
                                            {bc.isk !== 'used' && <span className="text-secondary">n/a</span>}
                                        </td>
                                        <td>
                                            {bc.isk !== 'used' && <span>{format(new Date(bc.expires), 'PPP')}</span>}
                                            {bc.isk === 'used' && <span className="text-secondary">n/a</span>}
                                        </td>
                                    </tr>
                                )
                            }))
                        }
                    </tbody>
                </Table>
            </Container>
        </Fragment>
    )
}
export default BulkCodes;